module.exports = __webpack_public_path__ + "img/FPTemp5.43604ca9.png";